import { useAddExportsGroupingMetadata } from '@aibees/elephant/hooks/export/use-add-exports-grouping-metadata';
import { useAddLabelsGroupingMetadata } from '@aibees/elephant/hooks/labels/use-add-labels-grouping-metadata';
import { useSavedSearchMetadata } from '@aibees/elephant/hooks/saved-search/use-saved-search-metadata';
import { ROUTES } from '@aibees/elephant/router';
import { IconName } from '@aibees/shared/components';
import { useMatchRoute } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo, useEffect, useMemo } from 'react';
import { useSearchListCardStore } from '../../store';
import { SearchListCardGrouping } from '../../types';
import { listGrouping } from './config';
import * as Styled from './styles';
import type { SearchListCardTypeFilterProps as Props } from './types';

export const SearchListCardTypeFilter = memo(({ className }: Props) => {
  const isPeoplePage = useMatchRoute(ROUTES.searchPeople);

  const { setGrouping, grouping, title } = useSearchListCardStore();
  useSavedSearchMetadata();

  const exportsGroupingOptions = useAddExportsGroupingMetadata(
    listGrouping.Export
  );
  const labelsGroupingOptions = useAddLabelsGroupingMetadata(
    listGrouping.Labels
  );
  const listsGroupingOptions = useAddLabelsGroupingMetadata(listGrouping.Lists);

  const handleChange = (value: string) => {
    setGrouping(value as SearchListCardGrouping);
  };

  const enrichedListGrouping = useMemo(() => {
    return {
      ...listGrouping,
      Export: exportsGroupingOptions,
      Labels: labelsGroupingOptions,
      Lists: listsGroupingOptions,
      Saved: listGrouping.Saved,
    };
  }, [exportsGroupingOptions, labelsGroupingOptions, listsGroupingOptions]);

  useEffect(() => {
    if (title) {
      const index = isPeoplePage ? 2 : 1;
      setGrouping(listGrouping[title]?.at(index)?.key as string);
    }
  }, [title, isPeoplePage, setGrouping]);

  const dropdownOptions = useMemo(() => {
    if (!title || !enrichedListGrouping[title]) return [];

    return enrichedListGrouping[title].map((option) => ({
      key: option.key || '',
      value: option.key || '',
      label: option.value,
      metadata: option.metadata?.toString(),
      startIcon: option.icon as IconName,
      startIconSx: option.iconSx,
    }));
  }, [title, enrichedListGrouping]);

  return (
    <Styled.Wrapper
      className={classnames('SearchListCardTypeFilter', className)}
      size="small"
      fullWidth={false}
      value={grouping}
      onChange={handleChange}
      options={dropdownOptions}
    />
  );
});

SearchListCardTypeFilter.displayName = 'SearchListCardTypeFilter';
